module.exports = __webpack_public_path__ + "static/media/topo_template.abf3070f.png";